import React from 'react';
import PropTypes from 'prop-types';

import { Button, ButtonEnums } from '../../components';
import classNames from 'classnames';

function ActionButtons({ actions, disabled = false, t }) {
  return (
    <React.Fragment>
      {actions.map((action, index) => (
        <Button
          key={index}
          onClick={action.onClick}
          disabled={disabled || action.disabled}
          type={ButtonEnums.type.secondary}
          size={ButtonEnums.size.small}
          className={classNames('transition duration-200', {
            'ml-2': index > 0,
            'bg-[rgba(76,82,79,0.5)] hover:bg-[#6a726f]': !action.disabled && !disabled,
          })}
        >
          {t ? t(action.label) : action.label}
        </Button>
      ))}
    </React.Fragment>
  );
}

ActionButtons.propTypes = {
  actions: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      onClick: PropTypes.func.isRequired,
      disabled: PropTypes.bool,
    })
  ).isRequired,
  disabled: PropTypes.bool,
};

export default ActionButtons;
